/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LastSessionUserAverages
 */
export interface LastSessionUserAverages {
    /**
     * Average session duration in minutes over last 30 sessions
     * @type {number}
     * @memberof LastSessionUserAverages
     */
    sessionDuration?: number;
    /**
     * Average XP earned per session over last 90 days
     * @type {number}
     * @memberof LastSessionUserAverages
     */
    xpPerSession?: number;
    /**
     * 
     * @type {number}
     * @memberof LastSessionUserAverages
     */
    questsPerSession?: number;
}

/**
 * Check if a given object implements the LastSessionUserAverages interface.
 */
export function instanceOfLastSessionUserAverages(value: object): value is LastSessionUserAverages {
    return true;
}

export function LastSessionUserAveragesFromJSON(json: any): LastSessionUserAverages {
    return LastSessionUserAveragesFromJSONTyped(json, false);
}

export function LastSessionUserAveragesFromJSONTyped(json: any, ignoreDiscriminator: boolean): LastSessionUserAverages {
    if (json == null) {
        return json;
    }
    return {
        
        'sessionDuration': json['sessionDuration'] == null ? undefined : json['sessionDuration'],
        'xpPerSession': json['xpPerSession'] == null ? undefined : json['xpPerSession'],
        'questsPerSession': json['questsPerSession'] == null ? undefined : json['questsPerSession'],
    };
}

export function LastSessionUserAveragesToJSON(json: any): LastSessionUserAverages {
    return LastSessionUserAveragesToJSONTyped(json, false);
}

export function LastSessionUserAveragesToJSONTyped(value?: LastSessionUserAverages | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sessionDuration': value['sessionDuration'],
        'xpPerSession': value['xpPerSession'],
        'questsPerSession': value['questsPerSession'],
    };
}

